import React, { Dispatch, SetStateAction, useRef } from 'react';
import classnames from "classnames";
import { Font } from "@/sunzi";
import { i18n } from "@/utils";
import { MiniMeLineText } from "./mini-me";
import Icon from './icon';
import styles from './style.less';

interface TextEditProps {
  /** 刻字相关数据 */
  lineText?: MiniMeLineText;
  /** 刻字变量 */
  text: string;
  /** 当前选择的字体 */
  fontSelected: Font | undefined;
  /** 设置刻字变量 */
  setText: Dispatch<SetStateAction<string>>;
  /** 设置当前选择的字体 */
  setFontSelected: Dispatch<SetStateAction<Font | undefined>>;
  /** 确认回调 */
  onConfirm: () => void;
}

const TextEdit: React.FC<TextEditProps> = ({ lineText, text, fontSelected, setText, setFontSelected, onConfirm }) => {

  /** textarea DOM元素 */
  const _textarea = useRef<HTMLTextAreaElement>(null);

  return (
    <div className={styles.textEditLayout}>
      <div className={styles.inputLayout}>
        <div className={styles.textareaWarpper}>
          <textarea
            ref={_textarea}
            value={text}
            placeholder={lineText?.defaultText}
            onChange={(event) => setText(event.target.value)}
          />
          {text.length > 0 &&
          <div className={styles.clear} onClick={() => setText('')}>
            <Icon type="close-circle" color="#cfd2d6" size={20} />
          </div>
          }
        </div>
        <div className={styles.confirm} onClick={onConfirm}>
          <Icon type="confirm" color="#fff" size={30} />
        </div>
      </div>
      <div className={styles.fontOptions}>
        {lineText!.fonts.map(item => (
          <div key={item.id} className={styles.fontOptionLayout}>
            <div
              style={{ fontFamily: item.name }}
              className={classnames(styles.fontOption, {
                [styles.fontSelected] : fontSelected!.id === item.id,
              })}
              onClick={() => setFontSelected(item)}
            >
              {item.name}
              {fontSelected!.id === item.id &&
                <Icon className={styles.selectedIcon} type="confirm" color="#fff" size={12} />
              }
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TextEdit;
